import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppService } from 'src/app/shared/services/app.service';

@Injectable({
  providedIn: 'root'
})
export class AddMunicipalitiesService {

  constructor(
    private appService: AppService,
    private http: HttpClient,
  ) { }




  getRegions() {
    console.log("this.appService.config.API_____________");

    console.log(this.appService.config.API);

    return this.http.get<any>(`${this.appService.config.API}/users/regions`);

  }

  getCityBoundaries(city){
    const reqheaders = new HttpHeaders().set('token', this.appService.loggedUser.uuid)/*.append('x-role', this.role)*/;

     return this.http.get<any>(`${this.appService.config.API}/admin/settings/getCityBoundaries/${city}`,{ headers: reqheaders });
  }


  addMunicipulity(municipulityData){
    const reqheaders = new HttpHeaders().set('token', this.appService.loggedUser.uuid)/*.append('x-role', this.role)*/;

    return this.http.post<any>(`${this.appService.config.API}/admin/ministry/add_municipality`,municipulityData,{ headers: reqheaders })

  }

  // get_disabilities() {
  //   if (this.disabilities.length > 0) {
  //     return of(this.disabilities)
  //   } else {
  //     return this.http.get<Disability[]>(`${this.config.API}/users/regions`)
  //   }
  // }
}
